import React, { useEffect, useState } from "react";
import { Avatar, TablePagination } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { EVENTS_SERVICES } from "../../../../services";
import { ToastManager } from "../../../common/ToastContainer";
import FullPageProgress from "../../../common/FullPageProgress";
import { SESSION_AUTH } from "../../../../helpers/auth";
import Moment from "moment";
import DataTable from "../../../Table/DataTable";

const EventUserWatchlist = (props) => {
  const { module } = props;
  const [loader, setLoader] = useState(false);
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [userData, setUserData] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const { userId } = useParams();
  const [orgList, setOrgList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const defaultFilter = {
    page: 0,
    limit: 10,
    profileId: userId,
  };
  const [filter, setFilter] = useState(defaultFilter);

  useEffect(() => {
    if (userSession) {
      setUserData(userSession);
    } else {
      setUserData("");
    }
    return () => null;
  }, [userSession, module]);

  useEffect(() => {
    if (!userData || dataFetched) return;

    setLoader(true);
    setDataFetched(true);

    let parma = { ...filter };
    parma["userId"] = userData.userId;
    EVENTS_SERVICES.getWatchlist(parma)
      .then((data) => {
        setOrgList([]);
        if (data.code === 200) {
          setOrgList(data?.data?.list || []);
          if (data?.data.pageInfo.page === 0) {
            setTotalRows(data?.data.pageInfo?.count || 0);
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [userData, dataFetched, LOGOUT_USER_SESSION, filter]);
  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "sno",
      label: "S.No.",
    },
    {
      name: "orgLogo",
      label: "Logo",
      options: {
        customBodyRender: (item) => {
          return item?.logo ? (
            <Avatar
              style={{ background: item?.color }}
              src={item?.logo}
              alt=""
            />
          ) : null;
        },
      },
    },
    {
      name: "orgName",
      label: "Name",
      options: {
        customBodyRender: (item) => {
          return (
            <Link
              to={`${process.env.REACT_APP_EVENT_PLATFORM}/company/${item?.slug}`}
              target="_blank"
              className="text-link"
            >
              {item?.name}
            </Link>
          );
        },
      },
    },

    { name: "createdAt", label: "Date" },
  ];
  const handleChangePage = (event, newPage) => {
    setFilter((old) => ({
      ...old,
      page: newPage,
    }));
    setDataFetched(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter((old) => ({
      ...old,
      limit: event.target.value,
      page: 0,
    }));
    setDataFetched(false);
  };

  const customOption = {
    pagination: false,
  };

  return (
    <React.Fragment>
      {loader && <FullPageProgress />}

      <DataTable
        columns={columns}
        customOption={customOption}
        data={orgList.map((item, key) => {
          return {
            action: item,
            sno: filter?.page * filter?.limit + key + 1,
            orgName: { name: item.orgName, slug: item.orgSlug },
            orgLogo: { logo: item?.orgLogo, color: item?.orgLogoColor },
            createdAt: Moment(item?.createdAt).format("MMM DD, YYYY : hh:mm A"),
            id: item?._id,
          };
        })}
      />

      <TablePagination
        component="div"
        count={totalRows}
        page={filter.page}
        onPageChange={handleChangePage}
        rowsPerPage={filter.limit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        showFirstButton={true}
        showLastButton={true}
      />
    </React.Fragment>
  );
};

export default EventUserWatchlist;
